import Vue from 'vue';
import _ from "lodash";
import chartAPI from "../api/chart";
import i18n from '../../i18n';
import common from '../../libs/common';

const types = {
    LOADING: 'LOADING',
    SET_FIELD: 'SET_FIELD',
    LOADING_BY_KEY: 'LOADING_BY_KEY',
    GET_B_INDICATOR_SUCCESS: 'GET_B_INDICATOR_SUCCESS',
    GET_B_INDICATOR_FAIL: 'GET_B_INDICATOR_FAIL',
    GET_SECTOR_INDEXES_SUCCESS: 'GET_SECTOR_INDEXES_SUCCESS',
    GET_INDUSTRY_COMPONENTS_OK: 'GET_INDUSTRY_COMPONENTS_OK',
    GET_INDUSTRY_INDEXES_OK: 'GET_INDUSTRY_INDEXES_OK',
    GET_SECTOR_INDEXES_FAIL: 'GET_SECTOR_INDEXES_FAIL',
    GET_S2B_INDICATOR_SUCCESS: 'GET_S2B_INDICATOR_SUCCESS',
    GET_S2B_INDICATOR_FAIL: 'GET_S2B_INDICATOR_FAIL',
    GET_CAP2_GDP_OK: 'GET_CAP2_GDP_OK',
    GET_CAP2_INTEREST_OK: 'GET_CAP2_INTEREST_OK',
    GET_CAP2_INFLATION_OK: 'GET_CAP2_INFLATION_OK',
    GET_CAP2_UNEMPLOYMENT_OK: 'GET_CAP2_UNEMPLOYMENT_OK'
};

const initState = {
    form: {},
    avgBI: 0,
    latestBI: 0,
    components: [],
    industryComponentsChart: {
        series: [],
        chartOptions: {
            plotOptions: {
                bubble: {
                    zScaling: true,
                    minBubbleRadius: 5,
                    maxBubbleRadius: 60,
                },
            },
            dataLabels: {
                enabled: false,
                // formatter: function (val, opts) {
                //   const zValue = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].z;
                //   return zValue.toFixed(2); // Format z value to 2 decimal places
                // }
            },
            grid: {
                show: false
            },
            xaxis: {
                // min: 0,
                // max: 100,
                title: {
                    text: "MOS",
                },
                tickAmount: 5,
            },
            yaxis: {
                min: 0,
                max: 10,
                labels: {
                    formatter: function (value) {
                        return (value).toFixed();
                    }
                },
                title: {
                    text: "DCA",
                },
                tickAmount: 5,
            },
            tooltip: {
                enabled: true,
                shared: false,
                custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                    const data = w.config.series[seriesIndex].data[dataPointIndex];
                    return `
                        <div style="padding: 10px; border-radius: 5px; background: #fff; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);">
                        <strong>${w.config.series[seriesIndex].name}</strong><br>
                        MOS: ${data.x.toFixed(1)}%<br>
                        DCA: ${data.y.toFixed(1)}<br>
                        Percentage: ${(data.z / 100).toFixed(2)}%
                        </div>
                    `;
                },
            },
            legend: {
                position: "bottom",
            },
            fill: {
                opacity: 0.8,
            },
        }
    },
    industryIndexChart: {
        series: [],
        chartOptions: {
            chart: {
                width: 350,
                type: 'line',
                id: 'areachart-2',
                animations: {
                    enabled: false
                }
            },
            colors: ['var(--yellow)', 'var(--purple-dark)', 'var(--green)', 'var(--cyan)', 'var(--red)',
                'var(--orange)', 'var(--teal)', 'var(--indigo)', 'var(--blue)', 'var(--purple)',
                'var(--pink)', 'var(--dark)'
            ],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            grid: {
                show: false
            },
            xaxis: {
                type: 'category',
                labels: {
                    formatter: function (timestamp) {
                        var formattedDate = common.formatDate(timestamp);
                        return formattedDate;
                    }
                },
                tickAmount: 10
            },
            yaxis: {
                labels: {
                    formatter: function (value) {
                        return (value * 100).toFixed() + "%";
                    }
                },
                tooltip: {
                    enabled: true
                }
            },
        }
    },
    sectorIndexChart: {
        series: [],
        chartOptions: {
            chart: {
                width: 350,
                type: 'line',
                id: 'areachart-2',
                animations: {
                    enabled: false
                }
            },
            colors: ['var(--yellow)', 'var(--purple-dark)', 'var(--green)', 'var(--cyan)', 'var(--red)',
                'var(--orange)', 'var(--teal)', 'var(--indigo)', 'var(--blue)', 'var(--purple)',
                'var(--pink)', 'var(--dark)'
            ],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            grid: {
                show: false
            },
            xaxis: {
                type: 'category',
                labels: {
                    formatter: function (timestamp) {
                        var formattedDate = common.formatDate(timestamp);
                        return formattedDate;
                    }
                },
                tickAmount: 10
            },
            yaxis: {
                labels: {
                    formatter: function (value) {
                        return (value * 100).toFixed() + "%";
                    }
                },
                tooltip: {
                    enabled: true
                }
            },
        }
    },
    cap2BondChart: {
        series: [
            {
                name: i18n.t('indicators.s2b'),
                data: []
            },
            {
                name: `${i18n.t('indicators.market_capital')} (${i18n.t('units.c_billion')} ${i18n.t('units.dollar')})`,
                data: []
            },
            {
                name: `${i18n.t('indicators.bond10y')} (${i18n.t('units.percent')})`,
                data: []
            },
        ],
        chartOptions: {
            chart: {
                width: 350,
                type: 'area',
                id: 'areachart-2'
            },
            colors: ['var(--purple)', 'var(--green)', 'var(--yellow)'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            grid: {
                row: {
                    colors: ['var(--light)', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                type: 'category',
                labels: {
                    formatter: function (timestamp) {
                        var formattedDate = common.formatDate(timestamp);
                        return formattedDate;
                    }
                },
                tickAmount: 10
            }
        }
    },
    cap2GDPChart: {
        series: [
            {
                name: i18n.t('indicators.buffett'),
                data: []
            },
            {
                name: `${i18n.t('indicators.market_capital')} (${i18n.t('units.k_billion')} ${i18n.t('units.dollar')})`,
                data: []
            },
            {
                name: `GDP (${i18n.t('units.k_billion')} ${i18n.t('units.dollar')})`,
                data: []
            }
        ],
        chartOptions: {
            chart: {
                width: 350,
                type: 'area',
                id: 'areachart-2'
            },
            annotations: {
                yaxis: [
                    {
                        y: 1,
                        borderColor: 'var(--red)',
                        fontWeight: 'bold',
                        label: {
                            borderColor: 'var(--red)',
                            style: {
                                color: 'var(--dark)',
                                background: 'var(--white)',
                            },
                            text: 1
                        }
                    }
                ]
            },
            colors: ['var(--purple)', 'var(--green)', 'var(--yellow)'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            grid: {
                show: false
            },
            xaxis: {
                type: 'category',
                labels: {
                    formatter: function (timestamp) {
                        var formattedDate = common.formatDate(timestamp);
                        return formattedDate;
                    }
                },
                tickAmount: 10
            },
            yaxis: {
                min: 0,
                max: 1.2
            }
        }
    },
    cap2InflationChart: {
        series: [
            {
                name: `${i18n.t('indicators.market_capital')}-${i18n.t('indicators.inflation_rate')}`,
                data: []
            },
            {
                name: `${i18n.t('indicators.market_capital')} (${i18n.t('units.k_billion')} ${i18n.t('units.dollar')})`,
                data: []
            },
            {
                name: `${i18n.t('indicators.inflation_rate')} (${i18n.t('units.percent')})`,
                data: []
            }
        ],
        chartOptions: {
            chart: {
                width: 350,
                type: 'area',
                id: 'areachart-2'
            },
            annotations: {
                yaxis: [
                    
                ]
            },
            colors: ['var(--purple)', 'var(--green)', 'var(--yellow)'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'straight'
            },
            grid: {
                show: false
            },
            xaxis: {
                type: 'category',
                labels: {
                    formatter: function (timestamp) {
                        var formattedDate = common.formatDate(timestamp);
                        return formattedDate;
                    }
                },
                tickAmount: 10
            },
        }
    },
    cap2UnemploymentChart: {
        series: [
            {
                name: `${i18n.t('indicators.market_capital')}-${i18n.t('indicators.unemployment_rate')}`,
                data: []
            },
            {
                name: `${i18n.t('indicators.market_capital')} (${i18n.t('units.k_billion')} ${i18n.t('units.dollar')})`,
                data: []
            },
            {
                name: `${i18n.t('indicators.unemployment_rate')} (${i18n.t('units.percent')})`,
                data: []
            }
        ],
        chartOptions: {
            chart: {
                width: 350,
            },
            annotations: {
                yaxis: [
                    
                ]
            },
            colors: ['var(--purple)', 'var(--green)', 'var(--yellow)'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'straight'
            },
            grid: {
                show: false
            },
            xaxis: {
                type: 'category',
                labels: {
                    formatter: function (timestamp) {
                        var formattedDate = common.formatDate(timestamp);
                        return formattedDate;
                    }
                },
                tickAmount: 10
            },
        }
    },
    cap2InterestChart: {
        series: [
            {
                name: `${i18n.t('indicators.market_capital')}-${i18n.t('indicators.interest_rate')}`,
                data: []
            },
            {
                name: `${i18n.t('indicators.market_capital')} (${i18n.t('units.k_billion')} ${i18n.t('units.dollar')})`,
                data: []
            },
            {
                name: `${i18n.t('indicators.interest_rate')} (${i18n.t('units.percent')})`,
                data: []
            }
        ],
        chartOptions: {
            chart: {
                width: 350,
                type: 'line'
            },
            annotations: {
                yaxis: [
                    
                ]
            },
            colors: ['var(--purple)', 'var(--green)', 'var(--yellow)'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'straight'
            },
            grid: {
                show: false
            },
            xaxis: {
                type: 'category',
                labels: {
                    formatter: function (timestamp) {
                        var formattedDate = common.formatDate(timestamp);
                        return formattedDate;
                    }
                },
                tickAmount: 10
            }
        }
    }
}

const getters = {
    form: state => state.form,
    sort: state => state.sort,
    loading: state => state.loading,
    cap2BondChart: state => state.cap2BondChart,
    sectorIndexChart: state => state.sectorIndexChart,
    industryIndexChart: state => state.industryIndexChart,
    industryComponentsChart: state => state.industryComponentsChart,
    avgBI: state => state.avgBI,
    latestBI: state => state.latestBI,
    cap2GDPChart: state => state.cap2GDPChart,
    avgCap2GDP: state => state.avgCap2GDP,
    latestCap2GDP: state => state.latestCap2GDP,
    cap2InterestChart: state => state.cap2InterestChart,
    avgCap2Interest: state => state.avgCap2Interest,
    latestCap2Interest: state => state.latestCap2Interest,
    cap2InflationChart: state => state.cap2InflationChart,
    avgCap2Inflation: state => state.avgCap2Inflation,
    latestCap2Inflation: state => state.latestCap2Inflation,
    cap2UnemploymentChart: state => state.cap2UnemploymentChart,
    avgCap2Unemployment: state => state.avgCap2Unemployment,
    latestCap2Unemployment: state => state.latestCap2Unemployment,
}

const actions = {
    setField({ commit }, { key, value }) {
        commit(types.SET_FIELD, { key, value });
    },

    async getIndustryComponents({ commit, dispatch }, industryCode) {
        try {
            commit('LOADING_BY_KEY', { key: "industryComponentsLoading", status: true });
            const { data } = await chartAPI(dispatch).getIndustryComponents(industryCode);
            commit(types.GET_INDUSTRY_COMPONENTS_OK, data);
        } catch (e) {
            Vue.$log.error("Get industry's components failed", e);
            commit('LOADING_BY_KEY', { key: "industryComponentsLoading", status: false });
        }
    },

    async getIndustryIndexes({ commit, dispatch }, params) {
        try {
            commit('LOADING_BY_KEY', { key: "industryIndexLoading", status: true });
            const { data } = await chartAPI(dispatch).getIndustryIndexes(params);
            commit(types.GET_INDUSTRY_INDEXES_OK, data);
        } catch (e) {
            Vue.$log.error("Get industry's indexes failed", e);
            commit('LOADING_BY_KEY', { key: "industryIndexLoading", status: false });
        }
    },

    async getSectorIndexes({ commit, dispatch }, params) {
        try {
            commit('LOADING_BY_KEY', { key: "sectorIndexLoading", status: true });
            const { data } = await chartAPI(dispatch).getSectorIndexes(params);
            commit(types.GET_SECTOR_INDEXES_SUCCESS, data);
        } catch (e) {
            Vue.$log.error("Get sector's indexes failed", e);
            commit(types.GET_SECTOR_INDEXES_FAIL);
            commit('LOADING_BY_KEY', { key: "sectorIndexLoading", status: false });
        }
    },

    async getCap2UnemploymentChart({ commit, dispatch }, period) {
        try {
            commit('LOADING_BY_KEY', { key: "cap2UnemploymentChartLoading", status: true });
            const { data } = await chartAPI(dispatch).getCap2UnemploymentChart(period);
            commit(types.GET_CAP2_UNEMPLOYMENT_OK, data);
        } catch (e) {
            Vue.$log.error("getCap2UnemploymentChart failed", e);
            commit('LOADING_BY_KEY', { key: "cap2UnemploymentChartLoading", status: false });
        }
    },

    async getCap2InflationChart({ commit, dispatch }, period) {
        try {
            commit('LOADING_BY_KEY', { key: "cap2InflationChartLoading", status: true });
            const { data } = await chartAPI(dispatch).getCap2InflationChart(period);
            commit(types.GET_CAP2_INFLATION_OK, data);
        } catch (e) {
            Vue.$log.error("getCap2InflationChart failed", e);
            commit('LOADING_BY_KEY', { key: "cap2InflationChartLoading", status: false });
        }
    },

    async getCap2InterestChart({ commit, dispatch }, period) {
        try {
            commit('LOADING_BY_KEY', { key: "cap2InterestChartLoading", status: true });
            const { data } = await chartAPI(dispatch).getCap2InterestChart(period);
            commit(types.GET_CAP2_INTEREST_OK, data);
        } catch (e) {
            Vue.$log.error("getCap2InflationChart failed", e);
            commit('LOADING_BY_KEY', { key: "cap2InterestChartLoading", status: false });
        }
    },

    async getCap2GDPChart({ commit, dispatch }, period) {
        try {
            commit('LOADING_BY_KEY', { key: "cap2GDPChartLoading", status: true });
            const { data } = await chartAPI(dispatch).getCap2GDPChart(period);
            commit(types.GET_CAP2_GDP_OK, data);
        } catch (e) {
            Vue.$log.error("getCap2GDPChart failed", e);
            commit('LOADING_BY_KEY', { key: "cap2GDPChartLoading", status: false });
        }
    },

    async getBIndicator({ commit, dispatch }, period) {
        try {
            commit('LOADING_BY_KEY', { key: "bIndicatorLoading", status: true });
            const { data } = await chartAPI(dispatch).getBIndicator(period);
            commit(types.GET_B_INDICATOR_SUCCESS, data);
        } catch (e) {
            Vue.$log.error("Get Buffett's indicator failed", e);
            commit(types.GET_B_INDICATOR_FAIL);
            commit('LOADING_BY_KEY', { key: "bIndicatorLoading", status: false });
        }
    },

    async getCap2BondChart({ commit, dispatch }, period) {
        try {
            commit('LOADING_BY_KEY', { key: "cap2BondChartLoading", status: true });
            const { data } = await chartAPI(dispatch).getCap2BondChart(period);
            commit(types.GET_S2B_INDICATOR_SUCCESS, data);
        } catch (e) {
            Vue.$log.error("Get Stock-2-Bond indicator failed", e);
            commit(types.GET_S2B_INDICATOR_FAIL);
            commit('LOADING_BY_KEY', { key: "cap2BondChartLoading", status: false });
        }
    },
}

const mutations = {
    [types.SET_FIELD](state, params) {
        Vue.set(state.form, params.key, params.value);
    },
    [types.LOADING](state, loading) {
        Vue.set(state, 'loading', loading);
    },
    [types.LOADING_BY_KEY](state, data) {
        Vue.set(state.form, data.key, data.status);
    },

    [types.GET_CAP2_GDP_OK](state, data) {
        let values = [];
        let values1 = [];
        let values2 = [];

        data.values.map(item => {
            values.push(_.round(item, 3))
        });
        data.values1.map(item => {
            values1.push(_.round(item / 1000, 3))
        });
        data.values2.map(item => {
            values2.push(_.round(item / 1000, 3))
        });
        let latestValue = values[values.length - 1];
        Vue.set(state.cap2GDPChart.series[0], 'data', values);
        Vue.set(state.cap2GDPChart.series[1], 'data', values1);
        Vue.set(state.cap2GDPChart.series[2], 'data', values2);
        Vue.set(state.cap2GDPChart.chartOptions, 'labels', data.dates);
        Vue.set(state, 'avgCap2GDP', data.avgValue);
        Vue.set(state, 'latestCap2GDP', latestValue);
        Vue.set(state.form, 'cap2GDPChartLoading', false);
    },

    [types.GET_CAP2_INTEREST_OK](state, data) {
        let values = [];
        let values1 = [];
        let values2 = [];

        data.values.map(item => {
            values.push(_.round(item / 1000, 1))
        });
        data.values1.map(item => {
            values1.push(_.round(item / 1000, 3))
        });
        data.values2.map(item => {
            values2.push(_.round(item * 100, 1))
        });

        let latestValue = values[values.length - 1] * 1000;
        Vue.set(state.cap2InterestChart.series[0], 'data', values);
        Vue.set(state.cap2InterestChart.series[1], 'data', values1);
        Vue.set(state.cap2InterestChart.series[2], 'data', values2);
        Vue.set(state.cap2InterestChart.chartOptions, 'labels', data.dates);
        Vue.set(state, 'avgCap2Interest', _.round(data.avgValue));
        Vue.set(state, 'latestCap2Interest', latestValue);
        Vue.set(state.form, 'cap2InterestChartLoading', false);
    },

    [types.GET_CAP2_INFLATION_OK](state, data) {
        let values = [];
        let values1 = [];
        let values2 = [];

        data.values.map(item => {
            values.push(_.round(item / 1000, 1))
        });
        data.values1.map(item => {
            values1.push(_.round(item / 1000, 3))
        });
        data.values2.map(item => {
            values2.push(_.round(item * 100, 1))
        });

        let latestValue = _.round(values[values.length - 1] * 1000);
        Vue.set(state.cap2InflationChart.series[0], 'data', values);
        Vue.set(state.cap2InflationChart.series[1], 'data', values1);
        Vue.set(state.cap2InflationChart.series[2], 'data', values2);
        Vue.set(state.cap2InflationChart.chartOptions, 'labels', data.dates);
        Vue.set(state, 'avgCap2Inflation', _.round(data.avgValue));
        Vue.set(state, 'latestCap2Inflation', latestValue);
        Vue.set(state.form, 'cap2InflationChartLoading', false);
    },

    [types.GET_CAP2_UNEMPLOYMENT_OK](state, data) {
        let values = [];
        let values1 = [];
        let values2 = [];

        data.values.map(item => {
            values.push(_.round(item / 1000, 1))
        });
        data.values1.map(item => {
            values1.push(_.round(item / 1000, 3))
        });
        data.values2.map(item => {
            values2.push(_.round(item * 100, 1))
        });
        let latestValue = values[values.length - 1] * 1000;
        Vue.set(state.cap2UnemploymentChart.series[0], 'data', values);
        Vue.set(state.cap2UnemploymentChart.series[1], 'data', values1);
        Vue.set(state.cap2UnemploymentChart.series[2], 'data', values2);
        Vue.set(state.cap2UnemploymentChart.chartOptions, 'labels', data.dates);
        Vue.set(state, 'avgCap2Unemployment', _.round(data.avgValue));
        Vue.set(state, 'latestCap2Unemployment', latestValue);
        Vue.set(state.form, 'cap2UnemploymentChartLoading', false);
    },

    [types.GET_S2B_INDICATOR_SUCCESS](state, data) {
        let values = [];
        let values1 = [];
        let values2 = [];
        data.values.map(item => {
            values.push(_.round(item / 1000, 1))
        });
        data.values1.map(item => {
            values1.push(_.round(item / 100, 1))
        });
        data.values2.map(item => {
            values2.push(_.round(item * 100, 1))
        });
        Vue.set(state.cap2BondChart.series[0], 'data', values);
        Vue.set(state.cap2BondChart.series[1], 'data', values1);
        Vue.set(state.cap2BondChart.series[2], 'data', values2);
        Vue.set(state.cap2BondChart.chartOptions, 'labels', data.dates);
        Vue.set(state.form, 'cap2BondChartLoading', false);
    },

    [types.GET_INDUSTRY_COMPONENTS_OK](state, data) {
        Vue.set(state.industryComponentsChart, 'series', data);
        Vue.set(state.form, 'industryComponentsLoading', false);
    },

    [types.GET_INDUSTRY_INDEXES_OK](state, data) {
        Vue.set(state.industryIndexChart, 'series', data.items);
        Vue.set(state.industryIndexChart.chartOptions, 'labels', data.dates);
        Vue.set(state.form, 'industryIndexLoading', false);
    },

    [types.GET_SECTOR_INDEXES_SUCCESS](state, data) {
        let series = [];
        if (data.sectors.VNI) {
            let seriesData = [];
            data.sectors.VNI.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : 'VNIndex', 'data' : seriesData});
        }
        if (data.sectors.AGR) {
            let seriesData = [];
            data.sectors.AGR.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('AGR'), 'data' : seriesData});
        }
        if (data.sectors.ENE) {
            let seriesData = [];
            data.sectors.ENE.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('ENE'), 'data' : seriesData});
        }
        if (data.sectors.CON) {
            let seriesData = [];
            data.sectors.CON.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('CON'), 'data' : seriesData});
        }
        if (data.sectors.FIN) {
            let seriesData = [];
            data.sectors.FIN.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('FIN'), 'data' : seriesData});
        }
        if (data.sectors.HEA) {
            let seriesData = [];
            data.sectors.HEA.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('HEA'), 'data' : seriesData});
        }
        if (data.sectors.IND) {
            let seriesData = [];
            data.sectors.IND.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('IND'), 'data' : seriesData});
        }
        if (data.sectors.MAT) {
            let seriesData = [];
            data.sectors.MAT.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('MAT'), 'data' : seriesData});
        }
        if (data.sectors.REA) {
            let seriesData = [];
            data.sectors.REA.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('REA'), 'data' : seriesData});
        }
        if (data.sectors.TEC) {
            let seriesData = [];
            data.sectors.TEC.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('TEC'), 'data' : seriesData});
        }
        if (data.sectors.TEL) {
            let seriesData = [];
            data.sectors.TEL.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('TEL'), 'data' : seriesData});
        }
        if (data.sectors.UTI) {
            let seriesData = [];
            data.sectors.UTI.map(item => {
                seriesData.push(_.round(item, 2))
            });
            series.push({'name' : common.getSectorText('UTI'), 'data' : seriesData});
        }

        Vue.set(state.sectorIndexChart, 'series', series);
        Vue.set(state.sectorIndexChart.chartOptions, 'labels', data.dates);
        Vue.set(state.form, 'sectorIndexLoading', false);
    },

    [types.GET_SECTOR_INDEXES_FAIL](state) {
        Vue.set(state.form, 'sectorIndexLoading', false);
    },
}

export default {
    namespaced: true,
    state: initState,
    getters,
    actions,
    mutations
};